import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, CardGroup, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import PageHeader from 'app/components/header/PageHeader';
import useRequest from 'app/hooks/useRequest';
import UserContext from 'app/context/UserContext';
import { list, remove } from 'app/api/TaskService';
import axios from 'axios';
import { toast } from 'react-toastify';
import TaskFooter from './TaskFooter';

// Dummy SoftBadge component (replace with your actual implementation)
const SoftBadge = ({ children, bg, className, pill }) => (
  <span className={`badge bg-${bg} ${className}`}>{children}</span>
);

function TaskList() {
  const navigate = useNavigate();
  const { response, sendData } = useRequest();
  const { user } = useContext(UserContext);
  const [taskList, setTaskList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const fetchTaskList = () => {
    const config = list(user.token, page, limit);
    sendData(config);
  };

  useEffect(() => {
    if (response?.data?.data) {
      setTaskList(response.data.data);
    }
  }, [response]);

  useEffect(() => {
    fetchTaskList();
  }, [page, limit]);

  useEffect(() => {
    fetchTaskList();
  }, []);

  const handleDelete = async id => {
    try {
      await axios.request(remove(user.token, id));
      toast.success('Task deleted successfully');
      // Optionally re-fetch from server
      fetchTaskList();
      // Or optimistically update UI:
      // setTaskList(prev => prev.filter(task => task.id !== id));
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete task');
    }
  };

  return (
    <div>
      <PageHeader col={{ xs: 6 }} title="Add Task" className="mb-3">
        <Col className="d-flex justify-content-end">
          <Button
            variant="primary"
            size="sm"
            onClick={() => navigate('/dashboard/task/add-task')}
          >
            Add
          </Button>
        </Col>
      </PageHeader>

      {taskList.length ? (
        <Row className="g-0">
          <CardGroup>
            {taskList.map(task => (
              <Col className="mb-4 mb-lg-1 p-2" sm={4} lg={4} key={task.id}>
                <Card>
                  <Card.Img
                    variant="top"
                    src={task.backgroundImage}
                    alt={`${task.businessName} Background`}
                    style={{ height: '150px', objectFit: 'cover' }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      backgroundColor: 'rgba(0, 0, 0, 0.6)',
                      color: 'white',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '0.8rem',
                      fontWeight: 'bold',
                      zIndex: 1
                    }}
                  >
                    {
                      <div
                        style={{ textTransform: 'capitalize' }}
                        className={`${
                          task.status == 'ACCEPTED' && 'text-success'
                        } ${task.status == 'REJECTED' && 'text-danger'} ${
                          task.status == 'PENDING' && 'text-primary'
                        } fw-semibold text-capitalize text-end text-primary`}
                      >
                        {task.status.toLowerCase()}
                      </div>
                    }
                  </div>
                  <Card.Body>
                    <div className="d-flex align-items-center mb-2">
                      <img
                        src={task.logoImage}
                        alt="Logo"
                        style={{
                          width: '40px',
                          height: '40px',
                          objectFit: 'cover',
                          borderRadius: '50%',
                          marginRight: '10px'
                        }}
                      />
                      <Card.Title as="h5" className="mb-0">
                        <a href={`/dashboard/task/task-progress/${task.id}`}>
                          {task.businessName}
                        </a>
                      </Card.Title>
                    </div>

                    <Card.Text>
                      <strong>Leads:</strong> {task.noOfLeads}
                      <br />
                      <strong>Remaining:</strong> {task.remainingOfLeads}
                      <br />
                      <strong>Performing:</strong> {task.performingNoOfLeads}
                      <br />
                      {task.taskLocation && (
                        <>
                          <strong>Task Location:</strong> {task.taskLocation}
                        </>
                      )}
                    </Card.Text>

                    <Card.Text>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div>
                          <Link to={`/dashboard/task/edit-task/${task.id}`}>
                            <Button variant="primary" className="me-2 mb-1">
                              Edit
                            </Button>
                          </Link>

                          <Button
                            variant="danger"
                            onClick={() => handleDelete(task.id)}
                            className="me-2 mb-1"
                          >
                            Delete
                          </Button>
                        </div>

                        {task.paymentMethod && <div>
                          <p className="mb-0 small">
                            Paid Via {task.paymentMethod} Balance
                          </p>
                        </div>}
                      </div>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </CardGroup>
        </Row>
      ) : (
        <Card>
          <Card.Body className="fs--1 fs-lg-0">No records found.</Card.Body>
        </Card>
      )}
      <div className="mt-3">
        <TaskFooter
          page={taskList}
          pageIndex={page - 1}
          pageSize={limit}
          rowCount={response?.data?.pagination?.total || 0}
          setPageSize={value => {
            setLimit(Number(value));
            setPage(1);
          }}
          canPreviousPage={page > 1}
          canNextPage={page * limit < (response?.data?.pagination?.total || 0)}
          previousPage={() => setPage(prev => Math.max(prev - 1, 1))}
          nextPage={() => setPage(prev => prev + 1)}
          rowsPerPageOptions={[10, 20, 30]}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </div>
  );
}

export default TaskList;
